import React from "react";
import { Badge, Button, Box } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

export default function ChatButton({
  unreadCount,
  changeEvent,
  onOpenConversation,
}) {
  const handleClick = () => {
    onOpenConversation(true);

    if (unreadCount > 0) {
      changeEvent({
        unreadMessageCount: 0,
      });
    }
  };

  return (
    <Box sx={{ position: "relative", ml: 2 }}>
      <Button
        onClick={handleClick}
        variant="outlined"
        startIcon={<ChatBubbleOutlineIcon />}
        sx={{
          textTransform: "none",
          fontSize: "0.9rem",
          color: "#333",
          borderColor: "#ccc",
          "&:hover": {
            borderColor: "#333",
            backgroundColor: "#f5f5f5",
          },
        }}
      >
        Chat
        {unreadCount > 0 && (
          <Badge
            badgeContent={unreadCount > 9 ? "9+" : unreadCount}
            color="error"
            sx={{
              ml: 1,
              "& .MuiBadge-badge": {
                position: "relative",
                transform: "none",
                right: "auto",
                top: "auto",
              },
            }}
          >
            <span />
          </Badge>
        )}
      </Button>
    </Box>
  );
}
